import urlResource from '../home/constants/UrlResources';

function getQueryValue(name, location) {
  if (!location || !location.search) return '';

  const queryName = name.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${queryName}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(location.search);

  if (!results) return null;
  if (!results[2]) return '';

  try {
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  } catch (error) {
    return results[2].replace(/%20/g, ' ');
  }
}

function getAttributesFromUrl(location) {
  return location.pathname.split('?')[0].split('/');
}

function getExperience(location) {
  return getAttributesFromUrl(location)[1];
}

function getFaqInfo(resource, location) {
  const attributes = getAttributesFromUrl(location);
  const articleIdWithTitle = attributes[3] || '';
  const urlSegments = decodeURIComponent(articleIdWithTitle).split('-');
  const articleId = (urlSegments[urlSegments.length - 1]).toUpperCase();
  return {
    name: resource,
    id: articleId,
  };
}

function getTopicInfo(resource, location) {
  const attributes = getAttributesFromUrl(location);
  return {
    name: resource,
    id: attributes[3],
    // topicTree: [],
  };
}

function getResourceInfoForHome() {
  return {
    name: urlResource.HOME,
  };
}

function getQueryForSearch(resource, location) {
  return {
    name: resource,
    searchTerm: getQueryValue('q', location),
    channelOption: getQueryValue('channel', location),
  };
}

function parseResourceInfoFromLocation(location) {
  const attributes = getAttributesFromUrl(location);
  const resource = attributes[2];
  switch (resource) {
    case urlResource.ARTICLE:
      return getFaqInfo(resource, location);
    case urlResource.TOPIC:
      return getTopicInfo(resource, location);
    case urlResource.HOME:
      return getResourceInfoForHome();
    case urlResource.SEARCH:
      return getQueryForSearch(resource, location);
    default: {
      return {};
    }
  }
}

/*
 What's the sample output of getPageUrlInfoFromLocation function??

 Sample Url's:
 =============

 home page =  /smarthelp/personal/home
 article page  = /smarthelp/personal/article/838
 topic list page = /smarthelp/personal/L1TopicId/L2TopicId

 Page Info Parsed:
 ================

 home page = {
 experience: 'personal',
 resource: {
 name: 'home',
 },
 }

 article page = {
 experience: 'personal',
 resource: {
 name: 'article',
 id: '838',
 },
 }

 topic list page = {
 experience: 'personal',
 resource: {
 name: 'topic',
 id: 'L2TopicId',
 topicTree: [L1TopicId, L2TopicId]
 },
 }
 */

export default function getPageUrlInfoFromLocation(location) {
  const pageInfo = {
    experience: getExperience(location),
    resource: parseResourceInfoFromLocation(location),
  };
  return pageInfo;
}



// WEBPACK FOOTER //
// ./lib/location-helper.js